import * as Popover from "@radix-ui/react-popover";
import * as Tooltip from "@radix-ui/react-tooltip";
import React, { useMemo, Fragment, createContext, useContext, forwardRef, } from "react";
import { Text as RNText, View } from "react-native";
import "./styles.css";
import { pickChild } from "./utils/pick-child";
export const TooltipContext = createContext({
    usePopover: false,
});
export const Trigger = ({ children, ...rest }) => {
    const { usePopover } = useContext(TooltipContext);
    const TooltipTrigger = usePopover ? Popover.Trigger : Tooltip.Trigger;
    return (React.createElement(TooltipTrigger, { asChild: true, ...rest },
        React.createElement("div", null, children)));
};
export const Portal = ({ children, ...rest }) => {
    const { usePopover } = useContext(TooltipContext);
    const TooltipPortal = usePopover ? Popover.Portal : Tooltip.Portal;
    return React.createElement(TooltipPortal, { ...rest }, children);
};
export const Root = ({ children, onDismiss, open, usePopover = false, ...rest }) => {
    const TooltipProvider = usePopover ? Fragment : Tooltip.Provider;
    const TooltipRoot = usePopover ? Popover.Root : Tooltip.Root;
    return (React.createElement(TooltipContext.Provider, { value: { usePopover } },
        React.createElement(TooltipProvider, null,
            React.createElement(TooltipRoot, { onOpenChange: (state) => {
                    if (open === undefined && state === false) {
                        onDismiss?.();
                    }
                }, open: open, ...rest }, children))));
};
export const Arrow = ({ backgroundColor, ...rest }) => {
    const { usePopover } = useContext(TooltipContext);
    const TooltipArrow = usePopover ? Popover.Arrow : Tooltip.Arrow;
    return React.createElement(TooltipArrow, { fill: backgroundColor ?? "#000", ...rest });
};
export const Content = forwardRef(function UniversalTooltipContent({ children, ...rest }, ref) {
    const { side, dismissDuration, containerStyle, presetAnimation, backgroundColor, borderRadius, onTap, className, disableTapToDismiss, maxWidth, ...restProps } = rest;
    const { usePopover } = useContext(TooltipContext);
    const [, triggerChildren] = pickChild(children, Text);
    const TooltipContent = usePopover ? Popover.Content : Tooltip.Content;
    const animationClass = useMemo(() => {
        switch (presetAnimation) {
            case "fadeIn":
                return `tooltip-fade-in-${side ?? "top"}`;
            case "zoomIn":
                return "tooltip-zoom-in";
            default:
                return "";
        }
    }, [presetAnimation]);
    return (React.createElement(TooltipContent, { side: side, ref: ref, className: `${animationClass} ${className}`, onClick: onTap, ...restProps },
        React.createElement(View, { style: [
                triggerChildren?.length > 0
                    ? { backgroundColor, borderRadius, maxWidth, ...containerStyle }
                    : {},
            ] }, children)));
});
export const Text = ({ text, ...rest }) => {
    return React.createElement(RNText, { ...rest }, text);
};
//# sourceMappingURL=universal-tooltip.web.js.map